var lazy = {

    init : () => {
        const elms = helper.element(".lazy", true);
        const io = new IntersectionObserver(lazy.exec);
        let k = 0
        Array.prototype.forEach.call(elms, elm => {
            io.observe(elm);
            elm.style.animationDelay = k + "s";
            k = k + .16;
            if (k > .64) {
                k = .64;
            }
        });
    },

    exec : (items) => {
        items.forEach((item) => {
            if (item.intersectionRatio > 0) {
                item.target.classList.add("show");
            }
        });
    }
};